import { renderSubmitBtn, attachSubmitBtnEvent } from './screenOutPage';
import { publicAssetsPrefix } from '../../../../configuration';

// for some reason the line-height of the span generates a + 8px difference than expected`
const renderCounter = (value = 3) => `
    <div class="countdown">
      <span class="loading__counter" style="width: 88px; line-height: 80px">${value}</span>
    </div>`;

let counterIntervalId;
const attachCounterEvents = (callback) => {
  let currValue = 3;

  if (counterIntervalId) {
    clearInterval(counterIntervalId);
  }

  const intervalMilliseconds = Pollfish.helper.isCypressEnv() ? 100 : 1000;
  counterIntervalId = setInterval(() => {
    currValue -= 1;
    if (currValue > 0) {
      $('.loading__counter').html(currValue);
    } else {
      clearInterval(counterIntervalId);
      counterIntervalId = null;

      $('.loading__counter').html('');
      if (callback) {
        callback();
      }
    }
  }, intervalMilliseconds);
};

const FetchAdditionalSurveysScreen = (options = {}) => {
  const { surveyExpired, lastPayload, callback } = options;

  const imgUrl = `${publicAssetsPrefix}/img/${
    surveyExpired ? 'expired.png' : 'search.png'
  }`;
  let imgClass = 'loading__search-image';

  const showCounter = surveyExpired && callback;
  const showButton = surveyExpired && !callback;

  let title = Pollfish.ui.getText(
    surveyExpired ? 'offerwall.history.survey_expired' : 'loading.title',
  );
  let subtitle = Pollfish.ui.getText(
    surveyExpired
      ? 'offerwall.notifications.survey_closed'
      : 'loading.subtitle',
  );
  const info = showButton ? '' : Pollfish.ui.getText('loading.info');

  if (lastPayload && lastPayload.status === 'success') {
    // For successful reroutes we don't want to show the 'you have been screened out' message
    // therefore we only show the icon and loading spinner
    title = '';
    subtitle = '';
  }

  if (surveyExpired) {
    imgClass = `${imgClass} e2e-expired`;
  }

  if (showCounter) {
    attachCounterEvents(callback);
  }

  if (showButton) {
    attachSubmitBtnEvent();
  }

  const hideImage =
    Pollfish.helper.hasCustomSurveyTheme() ||
    Pollfish.helper.whiteLabelEnabled();

  return `
  <div class="main-content__home loading">
    <div class="loading__header ${hideImage ? 'loading__header--short' : ''}">
      <h1>${title}</h1>
      <p>${subtitle}</p>
    </div>
    <div class="loading__image-container-search">
    ${
      hideImage
        ? ''
        : `<img src="${imgUrl}" alt="loading additional survey" class="${imgClass}">`
    }
      <p>${info}</p>
    </div>
    ${showCounter ? renderCounter() : ''}
    ${showButton ? renderSubmitBtn() : ''}
  </div>`;
};

export default FetchAdditionalSurveysScreen;
